import { createRoot } from 'react-dom/client'
import './polyfills' // Load iOS polyfills first
import './index.css'
import './styles/scrollbar.css'
import './lib/i18n/index'
import App from './App.tsx'

// Suppress ResizeObserver errors (harmless errors from Radix UI Select components)
// These errors occur when ResizeObserver callbacks trigger DOM changes that cause another resize
// They don't affect functionality but can clutter the console
const resizeObserverErrorHandler = (e: ErrorEvent) => {
  const errorMessage = e.message || '';
  const errorObj = e.error;
  const errorObjMessage = errorObj?.message || '';
  
  // Check various ways the ResizeObserver error can appear
  if (
    errorMessage.includes('ResizeObserver') ||
    errorMessage.includes('loop completed') ||
    errorMessage.includes('loop limit exceeded') ||
    errorObjMessage.includes('ResizeObserver') ||
    errorObjMessage.includes('loop completed') ||
    errorObjMessage.includes('loop limit exceeded') ||
    (errorObj && errorObj.toString().includes('ResizeObserver'))
  ) {
    e.stopImmediatePropagation?.();
    e.preventDefault?.();
    e.stopPropagation?.();
    return false;
  }
};

// Handle ResizeObserver errors in unhandled promise rejections
const resizeObserverRejectionHandler = (e: PromiseRejectionEvent) => {
  const reason = e.reason;
  const reasonStr = reason?.toString() || '';
  const reasonMessage = reason instanceof Error ? reason.message : String(reason);
  
  if (
    reasonStr.includes('ResizeObserver') ||
    reasonMessage.includes('ResizeObserver') ||
    reasonMessage.includes('loop completed') ||
    reasonMessage.includes('loop limit exceeded')
  ) {
    e.preventDefault?.();
    return false;
  }
};

// Add error handlers for ResizeObserver errors - use capture phase to catch early
if (typeof window !== 'undefined') {
  // Add handlers with capture phase (runs before other handlers)
  window.addEventListener('error', resizeObserverErrorHandler, true);
  window.addEventListener('unhandledrejection', resizeObserverRejectionHandler);
}

// Hide initial loader once React starts rendering
setTimeout(() => {
  if (typeof window !== 'undefined' && (window as any).hideLoader) {
    (window as any).hideLoader();
  }
}, 100);

createRoot(document.getElementById('root')!).render(
  <App />
)
